/**
 * 判断target是否el的子孙元素
 * @param {HTMLElement} target
 * @param {HTMLElement} el
 */
export const isChildEl = (target, el) => {
  if (el === target) {
    return true;
  }
  if (!target.parentElement) {
    return false;
  }
  target = target.parentElement;
  return isChildEl(target, el);
};

/**
 * 监听点击dom外面的事件
 * notice: 该函数仅落地页使用，不可移动到其他地方使用
 * @param {HTMLElement} dom
 * @param {(event: PointerEvent) => void} cb
 * @param {HTMLElement[]} filter 点击到filter不触发click outside事件
 */
export const listenClickOutside = (dom, cb, filter = []) => {
  filter = [...filter, dom];
  document.addEventListener('click', (event) => {
    for (const item of filter) {
      if (isChildEl(event.target, item)) {
        return;
      }
    }

    cb();
  });
};
